import angular from 'angular';
import uiRouter from 'angular-ui-router';
import ListComponent from './list.component';
import routing from './list.routes';

export default angular
  .module('verifyApp.cases.list', [uiRouter])
  .config(routing)
  .component('list', ListComponent)
  .name;



// WEBPACK FOOTER //
// ./client/app/cases/list/index.js